import { useMutation, useQuery, useQueryClient } from 'react-query'
import {
  systemIssuesService,
  type SystemIssuePendingAttachment,
} from '../../../services/systemIssuesService'
import { issueKey, issueMessagesKey, refreshIssueLists } from './useSystemIssues'

// Definida em `useSystemIssues` (que também a usa) — reexportada aqui para
// quem já importava deste arquivo, sem import circular.
export { issueMessagesKey }

export function useIssueMessages(issueId: number | null) {
  return useQuery(
    issueId ? issueMessagesKey(issueId) : ['system-issues', 'messages', 'idle'],
    () => systemIssuesService.listMessages(issueId as number),
    { enabled: !!issueId, staleTime: 10 * 1000 },
  )
}

export function useCreateIssueMessage(issueId: number) {
  const qc = useQueryClient()
  return useMutation(
    (payload: {
      content: string
      attachments?: SystemIssuePendingAttachment[]
    }) => systemIssuesService.createMessage(issueId, payload),
    {
      onSuccess: () => {
        qc.invalidateQueries(issueMessagesKey(issueId))
        qc.invalidateQueries(issueKey(issueId))
        refreshIssueLists(qc)
      },
    },
  )
}
